import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { useT } from '@/i18n/context';

/**
 * العودةُ إلى الصفحة الرئيسية (19 سبتمبر 2026).
 *
 * الشعارُ في الترويسة يعود إلى الرئيسية، لكنّ ذلك عُرفٌ يعرفه صانعو المواقع لا
 * كلُّ زائر — ومن دخل صفحةَ تسجيلٍ أو دخولٍ لا ترويسةَ أمامه أصلاً. فزرٌّ مكتوبٌ
 * بكلماته، في كل صفحةٍ علنية وفي بابَي الدخول والتسجيل.
 *
 * والسهمُ يُقلب أفقياً: الصفحةُ عربيةٌ من اليمين، فالعودةُ يميناً لا يساراً.
 */
export function BackHome({ className = '' }: { className?: string }) {
  const t = useT();
  return (
    <Link to="/" className={`back-home no-print ${className}`.trim()}>
      <Home size={15} aria-hidden /> {t('public.backHome')}
    </Link>
  );
}
